import React, { useState } from 'react'
import * as S from './styles';
import ContainerScreen from '@/main/components/shared/containerScreen/containerLayout';
import { getTranslateByKey } from '@/main/services/utils';
import { PaginationEnum } from '@/main/services/enum/PaginationEnum';
import GridScheduleReport from './gridDynamicReport/gridDynamicReport';
import FiltersOrderReportScheduleWrapper from './filtersDynamicReport/filtersDynamicReport';
import { IEditDataSchedule } from './types';
import { DynamicReportGridRequest } from '@/main/models/request/dynamicReportGridRequest';
import { DynamicReportGridResponse } from '@/main/models/response/dynamicReportResponse';
import FiltersDynamicReportWrapper from './filtersDynamicReport/filtersDynamicReport';

function DynamicReportScreen() {

  const [dataGrid, setDataGrid] = useState<DynamicReportGridResponse[]>([])
  const [formFilters, setFormFilters] = useState<DynamicReportGridRequest | null>(null)
  

  function onResetSearch() {
    setDataGrid([]);
    setFormFilters(null);
  }

  async function getData(filters: DynamicReportGridRequest | Partial<DynamicReportGridRequest> = {}, isResetSearch: boolean = true) {
    const request: DynamicReportGridRequest = {
      ...(isResetSearch ? {} : formFilters),
      ...filters as DynamicReportGridRequest,
      pageIndex: PaginationEnum.PageIndexIntial,
      pageSize: PaginationEnum.PageSize30,
    };

    onResetSearch()
    setFormFilters(request);
  };


  const titleScreen = `${getTranslateByKey(
    'module.report'
  )} > ${getTranslateByKey('screen.searchDynamicReport')}`;

  return (
    <ContainerScreen hasBackground title={titleScreen}>
      <FiltersDynamicReportWrapper
        onResetSearch={onResetSearch}
        getData={getData}
      />
      <GridScheduleReport
        dataGrid={dataGrid}
        formFilters={formFilters}
        setDataGrid={setDataGrid}
        getData={getData}
      />
    </ContainerScreen>
  )
}

export default DynamicReportScreen